import { getMerchantId } from 'util/merchant-id';
import { OfferParamsType } from './offers-domain.types';

export const getOfferParams = (params: OfferParamsType) => {
  const { campaignId, offerstatus, sortDirection, sortBy, ...rest } = params;

  return {
    merchantid: getMerchantId(),
    campaignid: campaignId === 'ALL' ? undefined : campaignId,
    offerstatus: offerstatus === 'ALL' ? undefined : offerstatus,
    sortby: sortBy,
    sortdirection: sortDirection,
    ...rest,
  };
};
